import React from "react";
import SplitButton from "common_components/buttons/split_button";

type DownloadButtonProps = {
  onDownloadDocx: () => void;
  onDownloadXlsx?: () => void;
};

const DownloadButton = ({
  onDownloadDocx,
  onDownloadXlsx,
}: DownloadButtonProps) => (
  <SplitButton
    options={[
      {id: "docx", label: "Download as Word .docx"},
      ...(onDownloadXlsx
        ? [{id: "xlsx", label: "Download as Excel .xlsx"}]
        : []),
      ...(shouldUpload() ? [{id: "upload", label: "Upload to CLM"}] : []),
    ]}
    containerStyles={{
      marginTop: "5px",
    }}
    size="small"
    color="primary"
    onClick={onDownloadDocx}
    onMenuCloseHandler={option =>
      option.id === "docx" ? onDownloadDocx() : onDownloadXlsx?.()
    }
    disableChangingSelectedOption
    excludeSelectedOptionFromMenu
    clickWithValue
  />
);
export default DownloadButton;

function shouldUpload() {
  return window.document.location.href.match(/organisation\/97/);
}
